@let users = (users$ | async) ?? [];
@let isLoadingUsers = usersService.usersLoadingState() === LoadingState.LOADING;
@let isLoadingRoles = usersService.rolesLoadingState() === LoadingState.LOADING;
@let isLoadedUsers = usersService.usersLoadingState() === LoadingState.READY;
@let usersCount = usersService.totalUsersCount();
@let roles = existingRoles() ?? [];

<section class="page-content page-viewport">
  <mon-page-toolbar
    titleTranslateKey="monitoring.menu.users"
    [searchControl]="searchControl"
    searchPlaceholderTranslateKey="monitoring.users.dashboard.search"
    [actions]="toolbarActions"
    [selectedFiltersCount]="selectedFiltersCount"
    (actionClick)="onToolbarAction($event)"
  >
    <div
      toolbarFilters
      class="users__filters"
    >
      <lib-multiselect
        titleTranslationKey="monitoring.roles.dashboard.role"
        chosenTranslationKey="monitoring.users.dashboard.roles-chosen"
        [options]="roles"
        [formControl]="rolesControl"
        [libSkeleton]="isLoadingRoles"
        (shouldLoadMoreOptions)="usersService.loadMoreRoles()"
      />
    </div>

    @if (isFiltersActive) {
      <div
        toolbarSelectedFilters
        class="users__selected-filters"
      >
        <lib-button
          (click)="clearAllFilters()"
          class="chip chip--button"
          buttonStyle="danger"
          buttonSize="medium"
        >
          <span>{{ 'monitoring.users.dashboard.clear-filters' | translate }}</span>
        </lib-button>

        @for (role of selectedRoles; track $index) {
          <lib-button
            (click)="removeRole(role)"
            class="chip chip--button"
            buttonStyle="danger"
            buttonSize="medium"
          >
            <lib-svg-icon
              icon="close"
              size="16"
            />
            <span>{{ role.label }}</span>
          </lib-button>
        }
      </div>
    }
  </mon-page-toolbar>

  <section class="page-content page-table page-table-scroll">
    <div class="page-table-scroll__content">
      <lib-table
        class="page-table-scroll__table users-table"
        [class.users-table--ready]="!isLoadingUsers && isLoadedUsers && usersCount > 0"
        trCustomClass="desktop-table-row--hoverable"
        [columns]="columns"
        [dataSource]="users"
        [cellTemplates]="{
          fullName: fullNameTpl,
          email: emailTpl,
          telegramLogin: telegramLoginTpl,
          roleName: roleNameTpl,
          status: statusTpl,
          lastLoginDate: lastLoginDateTpl,
        }"
        [loaded]="isLoadedUsers"
        [loading]="isLoadingUsers"
        (desktopRowClick)="
          openUserModal($event.fullName, UserAction.Edit, $event.id, $event.roleName)
        "
      ></lib-table>
    </div>

    <!-- пагинация -->
    @if (!(users.length === 0 && currentUserPage() === 1)) {
      <lib-pagination
        (paginationChange)="onPageChange($event)"
        [loading]="isLoadingUsers"
        [totalCount]="usersCount"
        [pageIndex]="currentUserPage()"
        [pageSize]="100"
      />
    }
  </section>

  <!-- шаблоны ячеек -->
  <ng-template
    #fullNameTpl
    let-row="data"
  >
    <div class="users__cell">
      <span class="users__fullname">{{ row.fullName || '—' }}</span>
    </div>
  </ng-template>

  <ng-template
    #emailTpl
    let-row="data"
  >
    <div class="users__cell">{{ row.email || '—' }}</div>
  </ng-template>

  <ng-template
    #telegramLoginTpl
    let-row="data"
  >
    <div class="users__cell">{{ row.telegramLogin || '—' }}</div>
  </ng-template>

  <ng-template
    #roleNameTpl
    let-row="data"
  >
    <div class="users__cell">
      <span class="users__role-chip">{{ row.roleName || '—' }}</span>
    </div>
  </ng-template>

  <ng-template
    #statusTpl
    let-row="data"
  >
    <div class="users__cell">
      @if (row.status) {
        <span
          class="users__status-chip status-chip"
          [class.status-chip--active]="row.status.id === UserStatusEnum.Active"
          [class.status-chip--blocked]="row.status.id === UserStatusEnum.Blocked"
        >
          {{ row.status.name }}
        </span>
      } @else {
        <span>—</span>
      }
    </div>
  </ng-template>

  <ng-template
    #lastLoginDateTpl
    let-row="data"
  >
    <div class="users__cell">
      @if (row.lastLoginDate) {
        <div>{{ row.lastLoginDate | date: 'dd.MM.yyyy' : 'UTC' }}</div>
        <div class="users__cell-time">
          {{ row.lastLoginDate | date: 'HH:mm:ss' : 'UTC' }}
          (UTC)
        </div>
      } @else {
        <span>—</span>
      }
    </div>
  </ng-template>
</section>
